module.exports = __webpack_public_path__ + "static/media/holdings selected.23c94f2d.svg";